import React, { useState } from 'react';
import './CallbackWidget.css';

const CallbackWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({ client_name: '', client_phone: '' });
  const [status, setStatus] = useState(null);

  const handleOpen = () => {
    setIsOpen(true);
    setStatus(null);
  };

  const handleClose = () => {
    setIsOpen(false);
    setFormData({ client_name: '', client_phone: '' });
    setStatus(null);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('pending');

    try {
      const payload = {
        ...formData,
        operator_name: 'Общий отдел (Сайт)',
        operator_phone: 'Основной номер',
      };

      const response = await fetch('/api/callback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error('Failed to submit callback request');

      await response.json();
      setStatus('success');
      setFormData({ client_name: '', client_phone: '' });
      window.setTimeout(() => {
        setIsOpen(false);
        setStatus(null);
      }, 2200);
    } catch (error) {
      setStatus('error');
      console.error('Submission error:', error);
    }
  };

  return (
    <div className={`callback-widget${isOpen ? ' callback-widget--open' : ''}`}>
      <button
        type="button"
        className="callback-widget__tab"
        onClick={isOpen ? handleClose : handleOpen}
        aria-expanded={isOpen}
        aria-controls="callback-widget-panel"
      >
        {isOpen ? '×' : 'Перезвоните мне'}
      </button>

      <aside
        id="callback-widget-panel"
        className="callback-widget__panel"
        aria-hidden={!isOpen}
      >
        <div className="callback-widget__head">
          <h2 className="callback-widget__title">Мы вам перезвоним</h2>
          <p className="callback-widget__subtitle">Оставьте контакты — свяжемся в ближайшее время</p>
        </div>

        <form className="callback-widget__form" onSubmit={handleSubmit}>
          <label className="callback-widget__field">
            <span className="callback-widget__label">Ваше имя</span>
            <input
              type="text"
              name="client_name"
              placeholder="Имя"
              value={formData.client_name}
              onChange={handleChange}
              required
              autoComplete="name"
            />
          </label>
          <label className="callback-widget__field">
            <span className="callback-widget__label">Телефон</span>
            <input
              type="tel"
              name="client_phone"
              placeholder="+998 …"
              value={formData.client_phone}
              onChange={handleChange}
              required
              autoComplete="tel"
            />
          </label>

          <button
            type="submit"
            className="callback-widget__submit"
            disabled={status === 'pending'}
          >
            {status === 'pending' ? 'Отправляю…' : 'Отправить'}
          </button>

          {status === 'success' && (
            <p className="callback-widget__status callback-widget__status--ok" role="status">
              Заявка отправлена. Мы свяжемся с вами.
            </p>
          )}
          {status === 'error' && (
            <p className="callback-widget__status callback-widget__status--err" role="alert">
              Ошибка отправки. Попробуйте ещё раз.
            </p>
          )}
        </form>
      </aside>
    </div>
  );
};

export default CallbackWidget;
